import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { forkJoin, switchMap } from 'rxjs';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { InitialDataDoneEvent } from '@shared/application/events/data-loader/initial-data-done.event';
import { PermissionFacade } from '../../application/facades/permission.facade';
import { OrganizationRepositoryAdapter } from 'src/app/core/entities/organization/infrastructure/adapters/organization-repository.adapter';


@Injectable({ providedIn: 'root' })
export class PermissionOnDataLoadSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly permissionFacade = inject(PermissionFacade);
  private readonly organizationService = inject(OrganizationRepositoryAdapter);

  constructor() {
    this.eventBus.ofType(InitialDataDoneEvent).pipe(
      switchMap(() =>
        this.organizationService.getCurrentOrganization().pipe(
          switchMap(organization => {
            const organizationId = organization?._id || '';

            return forkJoin({
              permissions: this.permissionFacade.fetchPermissions(),
              permissionGroups: this.permissionFacade.fetchPermissionGroups(organizationId)
            });
          })
        )
      ),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
